import { useQuery } from "react-query";
import { GET_EDUCATION_HISTORY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getEducationHistory } from "api/customers";

const useGetEducationHistory = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_EDUCATION_HISTORY, clientId],
    () => getEducationHistory(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    educationHistory: (data?.data || []) as any[],
    educationHistoryLoading: isLoading,
    refetchEducationHistory: refetch,
    ...rest,
  };
};

export default useGetEducationHistory;
